/**
 * Installs the native-preset submission recorder on the renderer's probe hook.
 *
 * Split from the recorder itself so the recording logic is importable by a unit
 * test without dragging in this file's module-level side effect. Same split, and
 * the same IRIS_E2E_TEST gate read through the preload bridge, as
 * device-probe.ts.
 *
 * Per rule reference-rules-in-comments (ai.knowledge/global).
 */
import {
  recordNativePresetSubmission,
  submissionLog,
  type SubmissionProbe
} from './native-preset-submission-recorder.js';

// Renderer-process gate: read through the preload bridge
// (window.electron.process.env), NOT bare `process.env` — the bundler's define
// replaces `process.env` object reads with `{}` at build time, which would make
// the gate compile-time false and the probe would silently never install.
const isE2eEnabled = (): boolean => {
  try {
    return (
      (globalThis as { window?: { electron?: { process?: { env?: Record<string, string> } } } })
        .window?.electron?.process?.env?.IRIS_E2E_TEST === '1'
    );
  } catch {
    return false;
  }
};

if (isE2eEnabled()) {
  const probe: SubmissionProbe = {
    record: recordNativePresetSubmission,
    cursor: submissionLog.cursor,
    since: submissionLog.since,
    dropped: submissionLog.dropped
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).__irisNativePresetSubmissions = probe;
}
